import { createSlice } from '@reduxjs/toolkit';

const eventsSlice = createSlice({
  name: 'events',
  initialState: {
    checkedItems: [],
    activeEventsTab: 'Wydarzenia',
    currentPage: 1,
    pageSize: 25,
    maxPages: 2,
    totalCount: 0,
    sortBy: null,
    sortDirection: null,
    keyword: null,
    searchValue: '',
    filterQuery: 'ALL',
    addModalOpen: false,
    editModalOpen: false,
    editedEvent: null,
    needRefresh: 1,
    modalViewActualTab: 'Dane podstawowe',
    addEventMode: false,
    duplicatedEventId: null,
    pendingEditReview: null,
  },
  reducers: {
    setEditedEvent(state, action) {
      state.editedEvent = action.payload;
    },
    setCheckedItems(state, action) {
      state.checkedItems = action.payload;
    },
    toggleCheckedItem(state, action) {
      const id = action.payload;
      if (state.checkedItems.includes(id)) {
        state.checkedItems = state.checkedItems.filter((item) => item !== id);
      } else {
        state.checkedItems.push(id);
      }
    },
    setPage(state, action) {
      state.checkedItems = [];
      state.currentPage = action.payload;
    },
    setPageSize(state, action) {
      state.checkedItems = [];
      state.pageSize = action.payload;
      state.currentPage = 1;
    },
    setMaxPages(state, action) {
      state.maxPages = action.payload;
    },
    setTotalCount(state, action) {
      state.totalCount = action.payload;
    },
    setSorting(state, action) {
      state.checkedItems = [];
      const { sortBy, sortDirection } = action.payload;
      state.sortBy = sortBy;
      state.sortDirection = sortDirection;
    },
    toggleNeedRefresh(state) {
      state.needRefresh = state.needRefresh === 1 ? 0 : 1;
    },
    toggleAddModal(state) {
      state.addModalOpen = !state.addModalOpen;
    },
    toggleEditModal(state) {
      state.editModalOpen = !state.editModalOpen;
    },
    openEditModal(state) {
      state.editModalOpen = true;
    },
    closeEditModal(state) {
      state.editModalOpen = false;
    },
    setKeyword(state, action) {
      state.keyword = action.payload;
    },
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    setFilterQuery(state, action) {
      state.filterQuery = action.payload;
    },
    setModalViewActualTab(state, action) {
      state.modalViewActualTab = action.payload;
    },
    setAddEventMode(state, action) {
      state.addEventMode = action.payload;
    },
    setDuplicatedEventId(state, action) {
      state.duplicatedEventId = action.payload;
    },
    clearDuplicatedEventId(state) {
      state.duplicatedEventId = null;
    },
    setPendingEditReview(state, action) {
      state.pendingEditReview = action.payload;
    },
    clearPendingEditReview(state) {
      state.pendingEditReview = null;
    },
  },
});

export const {
  setEditedEvent,
  setCheckedItems,
  toggleCheckedItem,
  setPage,
  setPageSize,
  setMaxPages,
  setTotalCount,
  setSorting,
  toggleAddModal,
  toggleEditModal,
  openEditModal,
  closeEditModal,
  toggleNeedRefresh,
  setKeyword,
  setSearchValue,
  setFilterQuery,
  setModalViewActualTab,
  setAddEventMode,
  setDuplicatedEventId,
  clearDuplicatedEventId,
  setPendingEditReview,
  clearPendingEditReview,
} = eventsSlice.actions;

export default eventsSlice.reducer;
